import React, { Component } from "react";
import UserService from "../../services/UserService";
import AuthService from "../../services/AuthService";
import { Button, Table, Spinner, Modal, Form, Alert, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Pagination from "@material-ui/lab/Pagination";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      showResetModal: false,
      showEditModal: false,
      showDeleteModal: false,
      selectedUser: null,
      formData: {
        nombre: '',
        apellido: '',
        email: ''
      },
      message: '',
      error: '',
      page: 1,
      count: 0,
      pageSize: 25,
      searchInput: ''
    };

    this.pageSizes = [25, 50];

    // Bind methods
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.loadUsers();
  }

  getRequestParams(searchInput, page, pageSize) {
    let params = {};

    if (searchInput) {
      params["search"] = searchInput;
    }

    if (page) {
      params["page"] = page - 1;
    }

    if (pageSize) {
      params["size"] = pageSize;
    }

    return params;
  }

  getRequestParams(search, page, pageSize) {
    let params = {};

    if (search) {
      params.search = search;
    }

    if (page !== undefined) {
      params.page = page - 1; // Backend uses 0-based page index
    }

    if (pageSize) {
      params.size = pageSize;
    }

    return params;
  }

  loadUsers = async () => {
    const { searchInput, page, pageSize } = this.state;
    const params = this.getRequestParams(searchInput, page, pageSize);

    this.setState({ loading: true });

    try {
      const res = await UserService.getAllFilter(params);
      const pageData = res.data;

      this.setState({
        users: pageData.content,
        count: pageData.totalPages,
        totalElements: pageData.totalElements,
        loading: false
      });
    } catch (err) {
      console.error("Error loading users:", err);
      this.setState({
        error: 'Error al cargar los usuarios',
        loading: false
      });
    }
  };

  handleResetPassword = (user) => {
    this.setState({
      selectedUser: user,
      showResetModal: true
    });
  };

  handleEditUser = (user) => {
    this.setState({
      selectedUser: user,
      formData: {
        nombre: user.nombre,
        apellido: user.apellido,
        email: user.email
      },
      showEditModal: true
    });
  };

  handlePageChange(event, value) {
    this.setState({
      page: value,
    }, () => {
      this.loadUsers();
    });
  }

  handlePageSizeChange(event) {
    this.setState({
      pageSize: event.target.value,
      page: 1
    }, () => {
      this.loadUsers();
    });
  }

  handleSearchInputChange(e) {
    this.setState({
      searchInput: e.target.value
    });
  }

  handleSearch = (e) => {
    e.preventDefault();
    this.setState({
      page: 1
    }, () => {
      this.loadUsers();
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        [name]: value
      }
    }));
  };

  handleSubmitEdit = (e) => {
    e.preventDefault();
    const { selectedUser, formData } = this.state;

    UserService.updateUser(selectedUser.id, formData)
      .then(response => {
        this.setState({
          showEditModal: false,
          message: 'Usuario actualizado correctamente',
          error: ''
        });
        this.loadUsers();
      })
      .catch(error => {
        console.error("Error updating user:", error);
        this.setState({
          error: error.response?.data?.message || 'Error al actualizar el usuario',
          message: ''
        });
      });
  };

  handleConfirmReset = () => {
    const { selectedUser } = this.state;

    AuthService.forgotPassword(selectedUser.email)
      .then(response => {
        this.setState({
          showResetModal: false,
          message: `Se ha enviado un correo a ${selectedUser.email} con las instrucciones para restablecer la contraseña`,
          selectedUser: null,
          error: ''
        });
      })
      .catch(error => {
        console.error("Error al solicitar restablecimiento de contraseña:", error);
        this.setState({
          error: error.response?.data?.message || 'Error al enviar el correo de restablecimiento de contraseña',
          message: ''
        });
      });
  };

  handleDeleteUser = (user) => {
    this.setState({
      selectedUser: user,
      showDeleteModal: true
    });
  };

  handleConfirmDelete = () => {
    const { selectedUser } = this.state;

    // Update user status to inactive (estado = 0)
    UserService.updateUser(selectedUser.id, { estado: 0 })
      .then(response => {
        this.setState({
          showDeleteModal: false,
          message: 'Usuario desactivado correctamente',
          selectedUser: null,
          error: ''
        }, () => {
          this.loadUsers(); // Refresh the user list
        });
      })
      .catch(error => {
        console.error("Error al desactivar el usuario:", error);
        this.setState({
          error: error.response?.data?.message || 'Error al desactivar el usuario',
          message: ''
        });
      });
  };

  render() {
    const {
      users,
      loading,
      showResetModal,
      showDeleteModal,
      showEditModal,
      selectedUser,
      formData,
      message,
      error,
      searchInput,
      pageSize,
      count,
      page,
      totalElements
    } = this.state;

    if (loading) {
      return (
        <div className="text-center mt-5">
          <Spinner animation="border" />
          <p>Cargando usuarios...</p>
        </div>
      );
    }


    return (
      <div className="container-fluid px-4 mt-4">
        <h2>Gestión de Usuarios</h2>

        {message && <Alert variant="success">{message}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}

        <div className="mb-3">
          <Row className="align-items-center">
            <Col md={4}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Buscar por nombre, apellido o email..."
                  value={searchInput}
                  onChange={this.handleSearchInputChange}
                  onKeyPress={e => e.key === 'Enter' && this.handleSearch(e)}
                />
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={this.handleSearch}
                >
                  Buscar
                </button>
              </div>
            </Col>
            {/* <Col md={4} className="d-flex justify-content-end align-items-center">
              <div className="d-flex align-items-center">
                <span className="me-2">Items por página:</span>
                <select
                  className="form-select form-select-sm"
                  style={{ width: 'auto' }}
                  value={pageSize}
                  onChange={this.handlePageSizeChange}
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </Col> */}
          </Row>
        </div>
        <div style={{ width: '100%', overflowX: 'auto', margin: '0', padding: '0' }}>

          <table className="table table-striped table-bordered table-sm" style={{ minWidth: '900px', width: '100%', marginBottom: '0' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>Usuario</th>
                <th>Nombres</th>
                <th>Apellidos</th>
                <th>Email</th>
                <th>Estado</th>
                <th style={{ width: '250px' }}>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {users.map((user, index) => (
                <tr key={user.id}>
                  <td>{index + 1}</td>
                  <td>{user.username}</td>
                  <td>{user.nombre}</td>
                  <td>{user.apellido}</td>
                  <td>{user.email}</td>
                  <td>{user.estado === 1 ? 'Activo' : 'Inactivo'}</td>
                  <td>
                    <div className="d-flex flex-wrap" style={{ gap: '5px' }}>
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => this.handleEditUser(user)}
                        style={{ whiteSpace: 'nowrap' }}
                        title="Editar"
                      >
                        <FontAwesomeIcon icon={faEdit} className="me-1" />
                      </Button>
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => this.handleResetPassword(user)}
                        style={{ whiteSpace: 'nowrap' }}
                        title="Resetear Contraseña"

                      >
                        <FontAwesomeIcon icon={faSync} className="me-1" />
                      </Button>
                      {/* <Button 
                      variant="danger" 
                      size="sm"
                      onClick={() => this.handleDeleteUser(user)}
                      style={{ whiteSpace: 'nowrap' }}
                      title="Eliminar Usuario"

                    >
                      <FontAwesomeIcon icon={faTrash} className="me-1" />
                    </Button> */}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


        <div className="d-flex justify-content-between align-items-center mt-3 pb-5" style={{ width: '100%', overflowX: 'auto' }}>
          <div>
            <div className="d-flex align-items-center">
              <span className="me-2">Items por página:</span>
              <select
                className="form-select form-select-sm"
                style={{ width: 'auto' }}
                value={pageSize}
                onChange={this.handlePageSizeChange}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
          <div>
            <nav>
              <ul className="pagination mb-0">
                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => this.handlePageChange(null, page - 1)}
                    disabled={page === 1}
                  >
                    &lt;
                  </button>
                </li>

                {/* First page */}
                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                  <button className="page-link" onClick={() => this.handlePageChange(null, 1)}>1</button>
                </li>

                {/* Dynamic page numbers */}
                {page > 4 && (
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                )}

                {Array.from({ length: Math.min(3, count - 2) }, (_, i) => {
                  const pageNum = Math.max(2, Math.min(page - 1, count - 3)) + i;
                  if (pageNum >= 2 && pageNum < count) {
                    return (
                      <li key={pageNum} className={`page-item ${page === pageNum ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => this.handlePageChange(null, pageNum)}>
                          {pageNum}
                        </button>
                      </li>
                    );
                  }
                  return null;
                })}

                {page < count - 3 && (
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                )}

                {/* Last page */}
                {count > 1 && (
                  <li className={`page-item ${page === count ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => this.handlePageChange(null, count)}>
                      {count}
                    </button>
                  </li>
                )}

                <li className={`page-item ${page === count ? 'disabled' : ''}`}>
                  <button
                    className="page-link"
                    onClick={() => this.handlePageChange(null, page + 1)}
                    disabled={page === count}
                  >
                    &gt;
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>

        {/* Delete User Modal */}
        <Modal show={showDeleteModal} onHide={() => this.setState({ showDeleteModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar Eliminación</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>¿Estás seguro de que deseas desactivar la cuenta de <strong>{selectedUser?.apellido} {selectedUser?.nombre}</strong>?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showDeleteModal: false })}>
              Cancelar
            </Button>
            <Button variant="danger" onClick={this.handleConfirmDelete}>
              Eliminar
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Reset Password Modal */}
        <Modal show={showResetModal} onHide={() => this.setState({ showResetModal: false })}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar Restablecimiento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Se enviará un enlace de restablecimiento de contraseña al correo electrónico:</p>
            <p className="fw-bold">{selectedUser?.email}</p>
            <p className="text-muted">El usuario deberá seguir las instrucciones del correo para establecer una nueva contraseña.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => this.setState({ showResetModal: false })}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={this.handleConfirmReset}>
              Enviar enlace de restablecimiento
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Edit User Modal */}
        <Modal show={showEditModal} onHide={() => this.setState({ showEditModal: false })}
          size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
          <Modal.Header closeButton>
            <Modal.Title>Editar Usuario</Modal.Title>
          </Modal.Header>
          <Form onSubmit={this.handleSubmitEdit}>
            <Modal.Body>
              <Form.Group className="mb-3">
                <Form.Label>Nombres</Form.Label>
                <Form.Control
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={this.handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Apellidos</Form.Label>
                <Form.Control
                  type="text"
                  name="apellido"
                  value={formData.apellido}
                  onChange={this.handleInputChange}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={this.handleInputChange}
                  required
                />
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => this.setState({ showEditModal: false })}>
                Cancelar
              </Button>
              <Button variant="primary" type="submit">
                Guardar Cambios
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default UserList;
